import { useQuery } from '@tanstack/react-query';
import { getRequestWithAuth } from '~/lib/api';
import { Connection } from '~/stores/connections';

export function useConnections() {
  return useQuery<Connection[]>({
    queryKey: ['connections'],
    queryFn: () => getRequestWithAuth('/api/v1/connections/listDataConnections'),
  });
}

export function useConnectionStatus(connectionId: string, enabled: boolean) {
  return useQuery<Connection>({
    queryKey: ['connection-status', connectionId],
    queryFn: () => getRequestWithAuth(`/api/v1/connections/${connectionId}`),
    refetchInterval: enabled ? 10000 : false,
    enabled,
  });
}
